import { ThemeKey } from "@smartsheet/design-tokens";
import { lodestarTheme } from "../lodestarTheme";
import { ursaDarkTheme } from "../ursaDarkTheme";
import { ursaTheme } from "../ursaTheme";

const ThemeMap = {
    "ursa-light": ursaTheme,
    "ursa-dark": ursaDarkTheme,
    "lodestar-light": lodestarTheme,
};
/**
 * A function that returns a theme object based on a valid theme key
 * @param themeKey a valid theme key, i.e. 'ursa-light' or 'lodestar-light'
 * @returns a theme object
 */
export const getTheme = (themeKey: ThemeKey) => {
    return ThemeMap[themeKey];
};
